// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"186":"company","592":"common","942":"article"}[chunkId] + "." + {"186":"8b8f8d6f","592":"4b691eda","942":"d0867706"}[chunkId] + ".css";
};